import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';
import { FA_SELECTOR } from '../../../styles/variables';
import { flex1, flexCenter } from '../../../styles/mixins';

const ITEM_HEIGHT = 70;

const templatesPopupInner = {
  '> .ant-popover-content > .ant-popover-inner': {
    boxShadow: `0 0 35px ${ThemeColors.COLOR_GREY6}`,
  },
};

export const useTemplatesListPopupStyles = createStyles(({ token }) => ({
  overlay: {
    ...templatesPopupInner,
    width: 300,

    '> .ant-popover-content > .ant-popover-inner': {
      ...templatesPopupInner['> .ant-popover-content > .ant-popover-inner'],
      backgroundColor: ThemeColors.COLOR_WHITE,
      overflow: 'hidden',

      '> .ant-popover-inner-content': {
        padding: 0,
        backgroundColor: ThemeColors.COLOR_WHITE,

        '> .Scrollbar': {
          height: `${4 * ITEM_HEIGHT}px !important`,
        },
      },
    },

    '.TemplatesList-Item': {
      position: 'relative',
      height: ITEM_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      cursor: 'pointer',

      '&.active': {
        border: `2px solid ${ThemeColors.COLOR_BLUE2}`,
      },
      '&.disabled': {
        opacity: 0.5,
      },

      '&:nth-child(odd)': {
        backgroundColor: ThemeColors.COLOR_GREY10,
      },
      '&:hover': {
        backgroundColor: ThemeColors.COLOR_WHITE6,
      },
      '&:active': {
        backgroundColor: ThemeColors.COLOR_GREY9_4,
      },

      '.TemplatesList-ItemLabel': {
        position: 'relative',
        lineHeight: '17px',
        padding: ThemeSpaces.SPACE_NORM,

        '&.has-popup': {
          padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
        },

        '> .text': {
          fontFamily: ThemeFont.FONT_CONDENSED,
          fontWeight: 'bold',
        },

        [FA_SELECTOR]: {
          color: ThemeColors.COLOR_RED,
        },

        '.to-left, .to-right': {
          position: 'absolute',
          top: '50%',
          transform: 'translate(0, -50%)',
        },
        '.to-left': {
          left: 0,
        },
        '.to-right': {
          right: 0,
        },
        '.SpinnerContainer': {
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translate(0, -50%)',
          width: 'auto',
        },
      },

      '.TemplatesList-ItemPreview': {
        width: '100%',
        height: 60,
        padding: `0 ${ThemeSpaces.SPACE_NORM0_5}px`,

        '.ant-popover-content .ant-popover-inner': {
          backgroundColor: ThemeColors.COLOR_WHITE,
          borderRadius: token.borderRadiusSM,
          boxShadow: `0 0 20px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.75)}`,
        },
        '.ant-popover-inner-content': {
          display: 'flex',
          padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM0_5}px 0 ${ThemeSpaces.SPACE_NORM0_5}px`,
          cursor: 'pointer',
        },

        '.col-1': {
          ...flex1(),
          marginRight: ThemeSpaces.SPACE_SM,
        },
        '.col-2': flex1(),
      },
    },
  },
  search: {
    padding: '4px 10px',

    '.InputSearchFlat': {
      borderRadius: 15,
      height: 24,
      padding: '0 10px',
      fontSize: 13,
      borderColor: ThemeColors.COLOR_GREY9_5,
      boxShadow: '1px 1px 3px 0 inset rgba(118, 131, 152, 0.85)',

      '.ant-input': {
        borderRadius: 0,
        margin: '3px 0',
      },
    },
  },
  header: {
    position: 'relative',
    height: 35,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    backgroundColor: ThemeColors.COLOR_WHITE3,
    border: `1px solid ${ThemeColors.COLOR_WHITE}`,
    boxShadow: `0 3px 10px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH3, 0.5)}`,

    '&::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 6,
      borderTop: `1px solid ${ThemeColors.COLOR_WHITE}`,
    },
  },
  headerItem: {
    fontSize: token.fontSizeHeading4,
    fontWeight: 300,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    [FA_SELECTOR]: {
      marginLeft: ThemeSpaces.SPACE_NORM,

      '&.active': {
        fontSize: 18,
        color: ThemeColors.COLOR_RED,
      },

      '&.fa-signal': {
        fontSize: 11,
        transform: 'rotateZ(90deg)',
      },
    },
  },
  noItems: {
    padding: ThemeSpaces.SPACE_NORM,
    display: 'flex',
    alignItems: 'center',

    [FA_SELECTOR]: {
      marginRight: ThemeSpaces.SPACE_NORM,
      color: ThemeColors.COLOR_ORANGE3,
    },

    '> div': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontWeight: 'bold',
    },
  },
  label: {
    '&&': {
      ...flexCenter(),

      [`@media (max-width: ${token.screenMDMax}px)`]: {
        color: ThemeColors.COLOR_RED,
        fontWeight: 500,

        [FA_SELECTOR]: {
          fontSize: 18,
          marginLeft: ThemeSpaces.SPACE_SM,
        },
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },
    },
  },
}));
